// extracted by mini-css-extract-plugin
export default {"item":"search-bar_item__m3zH4"};